import { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { deviceTypes } from '../../shared/enums/deviceTypes';
import { getAllowedTabs } from '../../shared/utils/tabsUtils.js';
import { useAccessibilityPageTitle } from '@skillz/accessibility';
import { teacherInOldAppFunc, usersInOldAppFunc } from '../../shared/utils/utils.js';
import NotAuthHome from '../../notAuth/components/pages/home/Home.js';
import useAnalytics from '../../shared/hooks/useAnalytics';
import usePlatformRedirectOpenerBridge from '../../shared/hooks/usePlatformRedirectOpenerBridge';
import useLrsReport from '../../shared/hooks/useLrsReport.js';
import pathRouts from '../../shared/enums/pathRoute';
import "../../shared/utils/globalIntegration"
import useDataInitialization from '../../shared/hooks/useDataInitialization';
import titleMap from '../../shared/components/pages/titleMap.js';
import useCanonicalLink from '../../shared/hooks/useCanonicalLink';
import AuthRedirect from '../../shared/components/features/authRedirect/AuthRedirect';
import Layout from '../layout/Layout.js';
import LayoutMobile from '../layout/layoutMobile/LayoutMobile';
import Home from '../pages/home/Home';
import HomeMobile from '../pages/home/homeMobile/HomeMobile.js';
import CalenderPage from '../pages/calenderPage/CalenderPage.js';
import MyLearningPage from '../pages/myLearningPage/MyLearningPage.js';
import UsefulToolsPage from '../pages/usefulToolsPage/UsefulToolsPage.js';
import DiscoveryPage from '../../shared/components/pages/discoveryPage/DiscoveryPage.js';
import ProfessionalDevelopmentPage from '../pages/ProfessionalDevelopmentPage/ProfessionalDevelopmentPage.js';
import MyLearningNmmPage from '../pages/myLearningPage/myLearningNmmPage/MyLearningNmmPage.js';
import AssignStudyGroupPage from '../pages/myLearningPage/assignStudyGroup/AssignStudyGroupPage.js';
import DelayNavigatePage from '../../shared/components/pages/delayNavigatePage/DelayNavigatePage.js';
import IframePage from '../../shared/components/pages/IframePage/IframePage.js';
import JwtAuthIframe from '../../shared/components/features/jwtAuthIframe/JwtAuthIframe.js';
import DynamicComponent from '../../shared/components/pages/DynamicComponent.js';
import ContentPromotionHost from '../../shared/components/features/contentPromotionPopup/ContentPromotionHost.js';
import '@skillz/accessibility/dist/index.css';
import './App.css';

function App() {

  const location = useLocation();
  const generalData = useSelector((state) => state.uiData.general);
  const deviceType = useSelector(state => state.responsive.deviceType);
  const { lang, texts, textsLoaded } = useSelector(state => state.translate);
  const { permissionLlist, permissionFilters } = useSelector((state) => state.uiData);
  const { isAuth, userDetails, user, isStudent, isManager } = useSelector(state => state.auth);
  const entities = useSelector(state => state.entities?.list);
  const [allowedTabs, setAllowedTabs] = useState([]);
  const [hasAccess, setHasAccess] = useState(false)
  useAnalytics();
  usePlatformRedirectOpenerBridge();
  useCanonicalLink();
  useDataInitialization();
  useAccessibilityPageTitle(texts.virtualCampus, titleMap, lang);
  useLrsReport(window.location.origin, window.config.platformName, true, hasAccess && isAuth && !!texts.virtualCampus);

  useEffect(() => {
    if (user) {
      setAllowedTabs(getAllowedTabs(user, userDetails, isStudent, lang, permissionLlist, isManager, entities, permissionFilters));
    }
  }, [user, userDetails, isStudent, lang, permissionLlist, isManager, entities, permissionFilters]);

  useEffect(() => {
    if (isAuth !== null) {
      if (generalData && userDetails) {
        if (isStudent) {
          if (usersInOldAppFunc(isStudent, user, userDetails))
            window.location.href = `${window.config.oldVirtualCampusUrl}`
          else {
            const { pathname, search, hash } = location;
            window.location.replace(`${window.location.origin}${window.config.baseStudentUrl}${pathname}${search}${hash}`);
          }
        }
        else if (teacherInOldAppFunc(isStudent, user, userDetails))
          window.location.href = `${window.config.oldVirtualCampusUrl}`
        else
          setHasAccess(true)
      }
    }
  }, [generalData, isStudent, user, isAuth, userDetails, deviceType, location])

  return (
    (() =>
      <>
          <Routes>
            {isAuth === false && (
              <>
                <Route path={pathRouts.HOME} element={textsLoaded ? <NotAuthHome /> : null} />
                <Route index element={<Navigate to={pathRouts.HOME} replace />} />
                <Route path="*" element={<AuthRedirect />} />
              </>
            )}
            {isAuth === true && hasAccess && textsLoaded &&
              <Route element={deviceType !== deviceTypes.mobile ? <Layout dynamicTabs={allowedTabs} /> : <LayoutMobile dynamicTabs={allowedTabs} />}>
                <Route>
                  <Route path="*" element={<Navigate to={pathRouts.HOME} />} />
                  <Route path={pathRouts.HOME} element={deviceType !== deviceTypes.mobile ? <Home /> : <HomeMobile />}  />
                  <Route path={pathRouts.CALENDAR} element={<CalenderPage />} />
                  <Route path={pathRouts.MYLEARNING} element={<MyLearningPage />} />
                  <Route path={pathRouts.USEFULTOOLS} element={<UsefulToolsPage />} />
                  <Route path={pathRouts.DISCOVERY} element={<DiscoveryPage />} />
                  <Route path={pathRouts.PROFFESSIONALDEVELOPMENT} element={<ProfessionalDevelopmentPage />} />
                  <Route path={`${pathRouts.MYLEARNING}/${pathRouts.DOMAIN}/:studyGroupId/:domainName`} element={<MyLearningNmmPage />} />
                  <Route path={`${pathRouts.MYLEARNING}/${pathRouts.ASSIGNSTUDYGTOUP}`} element={<AssignStudyGroupPage />} />
                  <Route path={`${pathRouts.DELAYNAVIGATE}/:link/:reloadOpener`} element={<DelayNavigatePage />} />
                  {allowedTabs.map(tab =>
                    <Route
                      key={tab.key}
                      path={tab.type === "component" ? `${tab.route}/*` : tab.route}
                      element={
                        tab.type === "iframe" ?
                          <IframePage {...tab} />
                          :
                          tab.type === "iframeJwt" ?
                            <JwtAuthIframe {...tab} />
                            :
                            <DynamicComponent tab={tab} compType={tab.key} />
                      }
                    />
                  )}
                </Route>
              </Route>
            }
          </Routes>
          {hasAccess && isAuth && <ContentPromotionHost />}
        {/* <AccessDeniedPopup
          isOpen={isAuth && isStudent === true}
          message={texts.teacherAreaOnly}
        /> */}
      </>
    )()
  );
}
export default App;